module.exports = __webpack_public_path__ + "img/9788992801157.90fe4c5e.jpg";